import { DetailCardSection, DetailList, DetailRow, formatDateTime, IdValue } from "@prequel/shared-components";

import { useProductContext } from "@/pages/import/DestinationsPage/ProductPage";

const ProductDetails = () => {
  const { product } = useProductContext();

  return (
    <div className="mt-6">
      <DetailCardSection title="Details">
        <DetailList>
          <DetailRow label="ID" value={<IdValue id={product.id} />} />
          <DetailRow label="Name" value={product.name} />
          <DetailRow label="Description" value={product.description || "—"} />
          <DetailRow label="Destinations" value={product.destinations.join(", ") || "—"} />
          <DetailRow label="Created at" value={formatDateTime(product.created_at)} />
          <DetailRow label="Updated at" value={formatDateTime(product.updated_at)} />
        </DetailList>
      </DetailCardSection>
    </div>
  );
};

export default ProductDetails;
